module.exports = __webpack_public_path__ + "img/133.5.27b3b0d9.png";